<template>

  <day-base-bar>
    <div class="text-right fill-height pe-2" :style="{backgroundColor: item.color}">
      {{ item.spacesSold }}/{{ item.spacesTotal }}
    </div>
  </day-base-bar>

</template>

<script setup lang="ts">

import DayBaseBar from './DayBaseBar.vue'
import type { DaySummaryInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: DaySummaryInventoryCalendarItem
}

defineProps<Props>()

</script>
